module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "titlepage",
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "pl-title"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Peril on the Mountain")]), _vm._v(" "), _c('p', {
    staticClass: "pl-author"
  }, [_vm._v("Elizabeth Goddard")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_c('b', [_vm._v("Previously published as "), _c('i', [_vm._v("Buried")]), _vm._v(" and "), _c('i', [_vm._v("Untraceable")])])]), _vm._v(" "), _c('p', {
    staticClass: "pl-logo"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "height": "70",
      "src": "image/LI_2020.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96961826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title_Page.vue
// module id = 63
// module chunks = 0